
import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-4">
          {/* Logo and Description */}
          <div className="flex flex-col items-center md:items-start md:mx-[15px]">
            <div className="flex items-center mb-4">
              <img src="/lovable-uploads/9ef63189-30d4-440c-aa62-4eb2d6d0c142.png" alt="Tagmusic Logo" className="h-10 mr-2" />
            </div>
            <p className="text-gray-400 text-sm text-center md:text-left">Building Trust in Music through Provenance Technology</p>
          </div>
          
           {/* Quick Links */}
          <div className="flex flex-col items-center md:items-center md:justify-start">
            <h3 className="font-medium mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-400 text-center">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/ai-music-framework" className="hover:text-white transition-colors">AI Music Framework</Link></li>
              <li><Link to="/copyrightability-engine" className="hover:text-white transition-colors">Copyrightability Engine</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              {/* <li><span className="cursor-default">Pilot Program</span></li> */}
            </ul>
          </div>
          
          {/* Company - New Section */}
          <div className="flex flex-col items-center md:items-center md:justify-start">
            <h3 className="font-medium mb-4">Company</h3>
            <ul className="space-y-2 text-gray-400 text-center">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><span className="cursor-default">Blog</span></li>
              <li><span className="cursor-default">Videos</span></li>
              <li><span className="cursor-default">In News</span></li>
            </ul>
          </div>
          
          {/* Connect - Right aligned on desktop, centered on mobile */}
          <div className="flex flex-col items-center md:items-center md:mx-[30px]">
            <h3 className="font-medium mb-4">Connect</h3>
            <div className="flex space-x-4">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400 hover:text-white transition-colors">
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
                </svg>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400 hover:text-white transition-colors">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                  <rect x="2" y="9" width="4" height="12" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400 hover:text-white transition-colors">
                  <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-10 pt-6 border-t border-gray-800 text-center text-gray-500 text-sm">© 2025 Vlinder Inc. All rights reserved.</div>
      </div>
    </footer>
  );
};

export default Footer;
